import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { root } from '../../../../../../store/constants';
import { IGetState } from '../../../../../../types/types';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../middlewares/segment';
import { SegmentCardPreviewSettingsSourceValue } from '../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onOpenCardPreviewSettings = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_PREVIEW_SETTINGS_OPENED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardPreviewSettingsSourceValue.TYPE_SWITCHER
        }));
        root.App.router.navigate(root.App.router.getUrl('preview'), { trigger: true });
    };
    return action;
};
